import React, { useEffect, useState } from "react";
import API from "../../utils/API";
import Swal from "sweetalert2";

export default function ManageParametersPage() {
  const [valorHomemHora, setValorHomemHora] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem('yc_usr_dt_ls')) {
      window.location.href = '/login';
    }

    const loadData = async () => {
      setIsLoading(true);
      try {
        const response = await API.getParameters(API.cancelToken());
        setValorHomemHora(response.data.valor_homem_hora || "");
      } catch (error) {
        console.error('Error loading parameter:', error);
        Swal.fire({
          title: 'Erro',
          text: 'Não foi possível carregar o parâmetro',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  const handleSave = async () => {
    try {
      await API.updateParameters(API.cancelToken(), {
        valor_homem_hora: parseFloat(valorHomemHora)
      });
      Swal.fire({
        title: 'Sucesso!',
        text: 'Parâmetro atualizado com sucesso.',
        icon: 'success',
        confirmButtonText: 'OK'
      });
    } catch (error) {
      console.error('Error saving parameter:', error);
      Swal.fire({
        title: 'Erro',
        text: 'Não foi possível atualizar o parâmetro.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#389E0D]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-10 px-4">
      <div className="bg-white shadow-xl rounded-lg w-full max-w-md p-6 md:p-8">
        <h1 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-6 text-center">
          Configurar Parâmetros
        </h1>

        <div className="mb-6">
          <label className="block text-gray-700 text-sm md:text-base font-medium mb-2" htmlFor="valor_homem_hora">
            Valor Homem/Hora (R$)
          </label>
          <input
            id="valor_homem_hora"
            type="number"
            step="0.01"
            value={valorHomemHora}
            onChange={(e) => setValorHomemHora(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#389E0D] text-base md:text-lg"
          />
        </div>

        <div className="flex flex-col sm:flex-row sm:justify-center gap-4">
          <button
            onClick={handleSave}
            className="w-full sm:w-auto bg-[#389E0D] text-white py-3 px-6 rounded-lg text-base md:text-lg font-medium hover:bg-[#2A7B0A] transition-colors"
          >
            Salvar Parâmetro
          </button>
        </div>
      </div>
    </div>
  );
}
